import { html, LitElement } from 'lit';

class ToujouBurger extends LitElement {
  static get is() {
    return 'toujou-burger';
  }

  static get properties() {
    return {
      toggleElement: {
        type: String,
        attribute: 'aria-controls',
      },
    };
  }

  render() {
    return html`
      <slot id="content"></slot>
    `;
  }

  /**
   * Set status of the burger button and the element to toggle (ex: #mainNavigation)
   * according to the value
   * @param value
   * @private
   */
  set _status(value) {
    this.setAttribute('aria-pressed', value);
    this.setAttribute('aria-expanded', value);
    this._elementToToggle.setAttribute('aria-hidden', !value);
  }

  connectedCallback() {
    super.connectedCallback();

    this._elementToToggle = document.getElementById(this.toggleElement);
    this.addEventListener('keydown', this._onKeydown);

    window.addEventListener('toujou-event-nav-close', () => {
      this._onNavClose();
    });
  }

  _onNavClose() {
    this.click();
  }

  _onKeydown(event) {
    if (event.code === 'Enter' || event.code === 'Space') {
      this.click();
    }
  }

  /**
   * React to navigation state input change
   * and add corresponding aria attribute values
   *
   * @param event
   * @private
   */
  _handleStateChange(event) {
    this._status = event.currentTarget.checked;

    this.dispatchEvent(new CustomEvent('toujou-burger-button-click', {
      bubbles: true,
      composed: true,
      detail: {
        state: event.currentTarget.checked,
      },
    }));
  }
}

customElements.define(ToujouBurger.is, ToujouBurger);
